<template>
    <MainContainer>
        
        <div class="col-sm-6 center pv4">
            <h6 class="mb3">Reset your password:</h6>

            <LabeledControl class="mb3" label="Email">
                <Textbox v-model="resetModel.email" type="email" />
            </LabeledControl>
            <LabeledControl class="mb3" label="Password">
                <Textbox v-model="resetModel.password" type="password" />
            </LabeledControl>
            <LabeledControl class="mb3" label="Confirm Password">
                <Textbox v-model="resetModel.password_confirmation" type="password" />
            </LabeledControl>        
            
            <TooliabaButton @click="passwordReset(resetModel)">Reset Password</TooliabaButton>            
        </div>

    </MainContainer>
</template>

<script>
import MainContainer from '@/components/layout/MainContainer.vue';
import LabeledControl from '@/components/controls/LabeledControl.vue';
import Textbox from '@/components/controls/Textbox.vue';
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';
import { mapActions } from 'vuex';

export default {
    components: {
        MainContainer,
        LabeledControl,
        Textbox,
        TooliabaButton
    },
    data: function() {
        return {
            resetModel: {
                email: '',
                token: '',
                password: '',
                password_confirmation: ''
            }
        };
    },
    methods: {
        ...mapActions('users', ['passwordReset'])
    },
    created: function() {
        this.resetModel.token = this.$route.params.token;
    }
};
</script>
